import { render, staticRenderFns } from "./VCommentPrintList.vue?vue&type=template&id=220bb653&scoped=true"
import script from "./VCommentPrintList.vue?vue&type=script&lang=js"
export * from "./VCommentPrintList.vue?vue&type=script&lang=js"
import style0 from "./VCommentPrintList.vue?vue&type=style&index=0&id=220bb653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220bb653",
  null
  
)

export default component.exports